<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :onLoaded="onLoaded"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            :actions="actions"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="deleteScanDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Are You Sure?</v-card-title
                >
                <div class="font-weight-medium mb-2" v-if="selected.length">
                    The selected scans will be removed
                </div>
                <div class="font-weight-medium mb-2" v-if="!selected.length">
                    Please select point-scans that was entered manually
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteScanDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        v-if="selected.length"
                        color="success"
                        @click="deleteScans()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data: () => ({
        title: "Attendance Scans",
        url: "",
        userBranch: "",
        actions: [],
        removeCardDialog: false,
        selected: [],
        processing: false,
        deleteScanDialog: false,

        columns: [
            {
                label: "Scan Date",
                field: "scanDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "Device ID",
                field: "deviceID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Card Number",
                field: "cardNum",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Name",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Heb Last Name",
                field: "lastNameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Eng Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Last Name",
                field: "lastName",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "familyID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Scan Type",
                field: "scanType",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Class",
                field: "class",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Points",
                field: "points",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "DOB",
                field: "dob",
                type: "date",
                format: "MM/dd/yyyy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher Heb",
                field: "teacherH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Teacher",
                field: "teacherName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered By",
                field: "enteredBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            // this.actions.push({
            //     text: "Remove Cards",
            //     action: this.openRemoveCards,
            //     showOnSelection: true,
            // });
            this.actions.push({
                text: "Delete",
                action: this.openDeleteScan,
                showOnSelection: true,
            });

            this.userBranch = this.$store.state.authentication.branch;

            this.url =
                "attendanceScans?" +
                (this.userBranch != "null"
                    ? "branch=" + this.userBranch
                    : "branch=");
        },
        openRemoveCards() {
            const selected = this.$refs.grid.getSelectedRowsData();

            this.selected = selected.filter((s) => s.cardNum != "N/A");

            this.removeCardDialog = true;
        },
        openDeleteScan() {
            const selected = this.$refs.grid.getSelectedRowsData();
            this.selected = selected.filter((s) => !s.deviceID);

            this.deleteScanDialog = true;
        },
        async deleteScans() {
            try {
                this.processing = true;
                const ids = this.selected.map((s) => s.scanID);

                await this.$http.post(
                    "api/studentAttendanceCards/RemoveScans?ids=",
                    ids,
                );

                this.deleteScanDialog = false;
                this.$refs.grid.reloadGrid();
                this.processing = false;

                this.$notify({
                    text: "Points Removed",
                    group: "notification",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        // async onRowClicked(row) {
        //     this.$router.push({
        //         name: "Account View",
        //         params: {
        //             id: row.utaId,
        //         },
        //     });
        // },
        onLoaded(data) {
            if (!data.length) return;

            data.forEach((d) => (d.playIcon = "mdi-play-circle"));
        },
        async removeCards() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/studentAttendanceCards/removeCards",
                    this.selected.map((s) => s.studentID),
                );

                this.removeCardDialog = false;
                this.$refs.grid.reloadGrid();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
